import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheDigitalFrontier from "./sections/TheDigitalFrontier";
import NextGenCapabilities from "./sections/NextGenCapabilities";
import OurTechEcosystem from "./sections/OurTechEcosystem";
import TheApexAdvantage from "./sections/TheApexAdvantage";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import InitiateTransformation from "./sections/InitiateTransformation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheDigitalFrontier />
      <NextGenCapabilities />
      <OurTechEcosystem />
      <TheApexAdvantage />
      <ClientSuccessStories />
      <InitiateTransformation />
      <Footer />
    </div>;
}